import type { RouteRecordRaw } from 'vue-router'
import { AppRoute } from '@/constants'
import { Administration } from '@/constants/rights'

export const ProcessRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.Process.path,
    name: AppRoute.Process.name,
    component: () => import('@/modules/process/Process.vue'),
    meta: {
      requiresAuth: true,
      authorities: [Administration],
    },
  },
  {
    path: AppRoute.Process.Detail.path,
    name: AppRoute.Process.Detail.name,
    component: () => import('@/modules/process/page/ProcessDetail.vue'),
    redirect: { name: AppRoute.Process.Detail.Main.name },
    props: true,
    meta: {
      requiresAuth: true,
      authorities: [Administration],
    },
    children: [
      {
        path: AppRoute.Process.Detail.Main.path,
        name: AppRoute.Process.Detail.Main.name,
        component: () => import('@/modules/process/page/MainTab.vue'),
      },
      {
        path: AppRoute.Process.Detail.Versions.path,
        name: AppRoute.Process.Detail.Versions.name,
        component: () => import('@/modules/process/page/VersionsTab.vue'),
      },
      {
        path: AppRoute.Process.Detail.Instances.path,
        name: AppRoute.Process.Detail.Instances.name,
        component: () => import('@/modules/process/page/InstancesTab.vue'),
      },
      {
        path: AppRoute.Process.Detail.Stats.path,
        name: AppRoute.Process.Detail.Stats.name,
        component: () => import('@/modules/process/page/StatisticsTab.vue'),
      },
      {
        path: AppRoute.Process.Detail.Access.path,
        name: AppRoute.Process.Detail.Access.name,
        component: () => import('@/modules/process/page/ProcessAccessTab.vue'),
      },
    ],
  },
  {
    path: AppRoute.Process.Edit.path,
    name: AppRoute.Process.Edit.name,
    component: () => import('@/modules/process/page/ProcessEdit.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      authorities: [Administration],
    },
  },
]
